module.exports = __webpack_public_path__ + "fonts/NotoSans-Light.8cc1e6e.ttf";